import { CheckCheck, Loader2 } from 'lucide-react'

import { CustomerSearchInputComponent } from '@/modules/shared/components/client-search-input.component'
import { Button } from '@/modules/shared/components/ui/button'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/modules/shared/components/ui/card'
import { DateTimePicker } from '@/modules/shared/components/ui/datetime-picker'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/modules/shared/components/ui/form'
import { Textarea } from '@/modules/shared/components/ui/textarea'

import { ModalCustomerComponent } from '../components/modal-entities.component'
import { useCustomerSelectionSchedule } from '../hooks/use-customer-selection-schedule.hook'
import type { useScheduleForm } from '../hooks/use-schedule-form.hook'

type ScheduleFormInterfaceProps = ReturnType<typeof useScheduleForm>

export function ScheduleFormInterface({
  form,
  handleSubmitSchedule,
  handleSelectClient,
  selectedSchedule,
  isSavingSchedule,
}: ScheduleFormInterfaceProps) {
  const { handleSearchClient, isLoadingRequestClient } =
    useCustomerSelectionSchedule()

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-primary">
            Novo Agendamento
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CustomerSearchInputComponent
            onSubmitRequest={handleSearchClient}
            defaultInputValue={selectedSchedule?.cliente}
          />
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(handleSubmitSchedule)}
              className="space-y-6 mt-6"
            >
              <FormField
                control={form.control}
                name="data"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Data e Hora do Agendamento</FormLabel>
                    <FormControl>
                      <DateTimePicker
                        date={field.value}
                        setDate={field.onChange}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="observacao"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Observação</FormLabel>
                    <FormControl>
                      <Textarea
                        {...field}
                        spellCheck={false}
                        placeholder="Digite aqui sua observação... (opcional)"
                        className="resize-y"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              <div className="w-full flex flex-1 justify-end">
                <Button
                  className="bg-green-600  hover:bg-green-700 fixed bottom-5 right-5 md:static md:rounded-md md:h-auto md:flex md:w-auto rounded-full h-14 w-14"
                  onClick={() => {
                    form.handleSubmit(handleSubmitSchedule)
                  }}
                  disabled={isSavingSchedule}
                >
                  {isSavingSchedule ? (
                    <Loader2 className=" md:mr-2 animate-spin" />
                  ) : (
                    <CheckCheck
                      size={20}
                      className="md:mr-2 size-24 md:size-auto"
                    />
                  )}
                  <p className="hidden md:flex">Salvar</p>
                </Button>
              </div>
            </form>
          </Form>
        </CardContent>
      </Card>

      <ModalCustomerComponent
        onSelectClient={handleSelectClient}
        isLoading={isLoadingRequestClient}
      />
    </>
  )
}
